import React, { useEffect } from 'react'
import {
  Switch,
  Route
} from 'react-router-dom'

import { SignUpFirstStep } from '@/pages/LoginPage/SignUp/steps/SignUpFirstStep/SignUpFirstStep'
import { SignUpSecondStep } from '@/pages/LoginPage/SignUp/steps/SignUpSecondStep/SignUpSecondStep'
import { SignUpThirdStep } from '@/pages/LoginPage/SignUp/steps/SignUpThirdStep/SignUpThirdStep'
import { SignUpFourthStep } from '@/pages/LoginPage/SignUp/steps/SignUpFourthStep/SignUpFourthStep'
import { SignUpFifthStep } from '@/pages/LoginPage/SignUp/steps/SignUpFifthStep/SignUpFifthStep'
import { SignUpBYODSetup } from '@/pages/LoginPage/SignUp/steps/SignUpBYODSetup/SignUpBYODSetup'

import { ChooseSubdomainStep } from '@/pages/LoginPage/SignUp/steps/ChooseSubdomainStep/ChooseSubdomainStep'
import * as Sentry from '@sentry/react'
import ReactGA from 'react-ga4'

import '../SignIn/SignIn.scoped.sass'
import './SignUp.sass'

export function SignUp (props) {
  useEffect(() => {
    ReactGA.initialize('G-E9LM6E4KBP')
    ReactGA.send('pageview')
  }, [])

  const { path } = props.match
  return <div className="sign-up">
    <div className="sign-up-container">
      <div className="steps">
        <Sentry.ErrorBoundary fallback={<></>}>
          <Switch>
            <Route exact path={`${path}/byod-setup-step`}>
              <SignUpBYODSetup/>
            </Route>
            <Route exact path={`${path}/waiting-page`}>
              <SignUpFifthStep />
            </Route>
            <Route exact path={`${path}/payment`}>
              <SignUpFourthStep />
            </Route>
            <Route exact path={`${path}/domain-selection`}>
              <SignUpThirdStep />
            </Route>
            <Route exact path={`${path}/choose-subdomain`}>
              <ChooseSubdomainStep/>
            </Route>
            <Route exact path={`${path}/verification-code`}>
              <SignUpSecondStep />
            </Route>
            <Route exact path={`${path}`}>
              <SignUpFirstStep />
            </Route>
          </Switch>
        </Sentry.ErrorBoundary>
      </div>
    </div>
  </div>
}
